import React, { useContext, useEffect, useRef, useState } from "react";
import { MdOutlineChevronLeft, MdOutlineChevronRight } from "react-icons/md";
import { TbDiscountCheckFilled } from "react-icons/tb";
import { gsap } from "gsap";
import Footer from "../components/modules/Footer/Footer";
import { Link } from "react-router-dom";
import globalContext from "../Context/GlobalContext";
import WorkWidthUsMobile from "./WorkWidthUsMobile";

export default function WorkWidthUs() {
  const contextData = useContext(globalContext);
  useEffect(() => {
    contextData.setIsHeaderShown(true);
  }, []);
  const sliderInfo = [
    {
      title: "گروه اول",
      services: [
        "تعویض روغن موتور",
        "تعویض فیلتر روغن",
        "تعویض فیلتر موتور",
        "تعویض فیلتر اتاق",
        "تعویض فیلتر بنزین",
        "شیشه شور",
        "رادیاتور",
        "باطری",
      ],
    },
    {
      title: "گروه دوم",
      services: [
        "انژکتور",
        "شمع",
        "گیربکس",
        "لاستیک",
        "لنت ترمز",
        "اینجکشن",
        "موتورشویی",
        "هیدرولیک",
      ],
    },
    {
      title: "گروه سوم",
      services: [
        "کلاچ",
        "تعلیق",
        "تسمه ها",
        "کاتالیزور",
        "کولر",
        "برق",
        "دیتیلینگ",
        "آچارکشی",
      ],
    },
  ];

  const [sliderNum, setSliderNum] = useState(1);
  const [sliderData, setSliderData] = useState(sliderInfo[0]);
  const refRSlide1 = useRef();
  const refRSlide2 = useRef();
  const refLSlide1 = useRef();
  const refLSlide2 = useRef();
  const [isAnimRunning, setIsAnimRunning] = useState(false);

  useEffect(() => {
    switch (sliderNum) {
      case 1: {
        setSliderData(sliderInfo[0]);
        break;
      }
      case 2: {
        setSliderData(sliderInfo[1]);
        break;
      }
      case 3: {
        setSliderData(sliderInfo[2]);
        break;
      }
    }
  }, [sliderNum]);

  useEffect(() => {
    gsap.set(refRSlide1.current, { transformPerspective: 800 });
    gsap.set(refLSlide1.current, { transformPerspective: 800 });
  }, []);
  const forwardGr = () => {
    if (!isAnimRunning) {
      setIsAnimRunning(true);
      gsap.to(refRSlide1.current, {
        duration: 0.5,
        keyframes: [
          {
            rotationY: "-=45",
            right: "-120px",
            opacity: "1",
          },

          { rotationY: "0", right: "100px", opacity: "0" },
          { right: "-100px" },
        ],
        onComplete: () => {
          setIsAnimRunning(false);
        },
      });
      gsap.to(refRSlide2.current, {
        duration: 0.5,
        keyframes: [
          {
            opacity: "0",
          },

          { opacity: "1" },
        ],
        onComplete: () => {
          setIsAnimRunning(false);
          if (sliderNum >= 3) {
            setSliderNum(1);
          } else {
            setSliderNum((prev) => prev + 1);
          }
        },
      });
    }
  };
  const backWardGr = () => {
    if (!isAnimRunning) {
      setIsAnimRunning(true);
      gsap.to(refLSlide1.current, {
        duration: 0.5,
        keyframes: [
          {
            rotationY: "+=45",
            left: "-120px",
            opacity: "1",
          },

          { rotationY: "0", left: "100px", opacity: "0" },
          { left: "-100px" },
        ],
        onComplete: () => {
          setIsAnimRunning(false);
        },
      });
      gsap.to(refLSlide2.current, {
        duration: 0.5,
        keyframes: [
          {
            opacity: "0",
          },

          { opacity: "1" },
        ],
        onComplete: () => {
          setIsAnimRunning(false);
          if (sliderNum <= 1) {
            setSliderNum(3);
          } else {
            setSliderNum((prev) => prev - 1);
          }
        },
      });
    }
  };

  return (
    <>
      <div className="relative  w-full hidden  min-[769px]:flex flex-col items-center justify-start bg-color-primary-A ">
        <div className="w-full max-w-[1440px] h-full flex flex-col items-center justify-start mt-[138px]">
          <div className="w-full flex items-center justify-center">
            <p className="font-font_primary_A font-bold text-[22px] text-color-primary-D ">
              همکاری یک امر متقابل است؛ که در بستر صداقت شکل می‌گیرد و رشد پیدا
              می‌کند
            </p>
          </div>

          <div className="w-full flex items-center justify-center mt-[23px]">
            <p
              dir="rtl"
              className="w-[1033px] h-[195px] font-font_primary_A  text-[16px] text-color-primary-D text-justify leading-[28px] "
            >
              زمانی که سخن از کسب و کار الکترونیک پیش می‌آید، بیشتر توجهات معطوف
              به خرید و فروش کالا می‌شود؛ در حالیکه خدمات خرید و فروش هم شامل
              این بستر می‌باشد. <br /> آنچه از ارزیابی انجام شده از بازار ایران
              مشهود است؛ خدمات خودرویی بزرگترین کسب کار خدماتی ایران می‌باشد،
              به‌طوری‌که روزانه خودروها، 85میلیون لیتر بنزین را می‌سوزانند.
              درحالی‌که هیچ بستر مناسبی برای خدمت‌رسانی به خودروها و مالکان
              آن‌ها به جز تعمیرگاه‌های مجاز شرکت‌های سازنده خودرویی وجود ندارد.
              در راستای بر طرف نمودن این ضعف و بنا به شناخت بازار ایران و
              توانمندی تعمیرگاه‌ها، اسکارپین تعمیرگاه‌ها را به سه گروه
              تقسیم‌بندی نموده است به‌طوری‌که این گروه‌بندی ارتباط مستقیم به
              توانمندی واحد صنفی دارد.
            </p>
          </div>

          <div
            dir="rtl"
            className="w-[1033px] h-[500px] flex items-center justify-center mb-[116px]"
          >
            <div className="flex-1 flex flex-col items-center justify-center gap-[86px]">
              <span className="w-[471px] h-[47px] font-font_primary_A text-[14px] text-color-primary-D text-justify">
                مالکان خودرو با نصب اپلیکیشن{" "}
                <h1 className="text-color-primary-B inline">اسکارپین</h1>{" "}
                می‌توانند بر 24پارامتر مصرفی خودرو در بازه‌های زمانی کوتاه مدت،
                میان مدت، بلند مدت و همچنین تعمیرات اساسی نظارت کامل داشته
                باشند.
              </span>
              <div className="flex items-center justify-center gap-x-[22px]">
                <Link to="/repair/links/app">
                  <button className="w-[185px] h-[50px] flex items-center justify-center bg-color-primary-B rounded-[5px] font-font_primary_A font-bold text-[16px] text-color-primary-D cursor-pointer">
                    نسخه اتوسرویس
                  </button>
                </Link>

                <Link to="/links/app">
                  <button className="w-[185px] h-[50px] flex items-center justify-center bg-color-primary-B rounded-[5px] font-font_primary_A font-bold text-[16px] text-color-primary-D cursor-pointer">
                    نسخه مالک خودرو
                  </button>
                </Link>
              </div>
            </div>

            <div className="w-[471px] h-full flex flex-col items-center justify-center bg-[#FFF] gap-y-[25px] rounded-[10px]">
              <div className="relative w-[396px] h-[351px] flex items-center justify-center">
                <div className="w-[257px] h-full flex flex-col items-center justify-start rounded-[2px] bg-color-primary-A z-10">
                  <div className="w-[250px] h-[60px] bg-[#ffb14b84] flex flex-col items-center justify-center rounded-[2px] mt-[4px] mx-auto">
                    <span className="font-font_primary_A font-bold text-[16px] text-color-primary-D">
                      {sliderData.title}
                    </span>
                    <span className="font-font_primary_A font-light text-[12px] text-color-primary-D">
                      اتوسرویس
                    </span>
                  </div>
                  <div className="w-full h-[90px] flex items-center justify-evenly">
                    <div
                      className={`relative w-[65px] h-[65px] flex flex-col items-center justify-center rounded-[10px] gap-y-[4px] ${
                        sliderNum === 1 ? "bg-[#fec62b8e]" : "bg-[#e5e5e5a4]"
                      } `}
                    >
                      <img
                        src="../assets/images/pieces/img_short.svg"
                        className="w-[30px] h-[30px]"
                      />
                      <span className="font-font_primary_A font-medium text-[10px] text-color-primary-D ">
                        کوتاه مدت
                      </span>
                      {sliderNum === 1 && (
                        <span className="absolute top-[-8px] left-[-8px] text-[22px] ">
                          <TbDiscountCheckFilled color="#256933" />
                        </span>
                      )}
                    </div>
                    <div
                      className={`relative w-[65px] h-[65px] flex flex-col items-center justify-center rounded-[10px] gap-y-[4px] ${
                        sliderNum === 2 ? "bg-[#fec62b8e]" : "bg-[#e5e5e5a4]"
                      }`}
                    >
                      <img
                        src="../assets/images/pieces/img_mid.svg"
                        className="w-[30px] h-[30px]"
                      />
                      <span className="font-font_primary_A font-medium text-[10px] text-color-primary-D ">
                        میان مدت
                      </span>
                      {sliderNum === 2 && (
                        <span className="absolute top-[-8px] left-[-8px] text-[22px] ">
                          <TbDiscountCheckFilled color="#256933" />
                        </span>
                      )}
                    </div>
                    <div
                      className={`relative w-[65px] h-[65px] flex flex-col items-center justify-center rounded-[10px] gap-y-[4px] ${
                        sliderNum === 3 ? "bg-[#fec62b8e]" : "bg-[#e5e5e5a4]"
                      } `}
                    >
                      <img
                        src="../assets/images/pieces/img_long.svg"
                        className="w-[30px] h-[30px]"
                      />
                      <span className="font-font_primary_A font-medium text-[10px] text-color-primary-D ">
                        بلند مدت
                      </span>
                      {sliderNum === 3 && (
                        <span className="absolute top-[-8px] left-[-8px] text-[22px] ">
                          <TbDiscountCheckFilled color="#256933" />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-center px-[8px]">
                    <p className="font-font_primary_A font-normal text-[10px] text-color-primary-D text-justify">
                      واحد های تجاری هستند که توانایی ارائه خدمات در هشت دسته
                      زیر و یا برخی از آن هارا داشته باشند:{" "}
                    </p>
                  </div>
                  <div className="w-full flex items-center  justify-start font-font_primary_A font-light text-[10px] text-color-primary-D mt-[6px] px-[20px]">
                    <ol className="list-[persian] space-y-[4px]">
                      {sliderData.services.map((service) => (
                        <li key={service}>{service}</li>
                      ))}
                    </ol>
                  </div>
                </div>

                <div
                  ref={refLSlide1}
                  className="absolute left-[-100px] w-[220px] h-[313px] bg-[#a98a5b7c] rounded-[10px] opacity-0 z-20"
                ></div>
                <div
                  ref={refLSlide2}
                  className="absolute left-[10px] w-[220px] h-[313px] bg-[#a98a5b7c] rounded-[10px]"
                ></div>

                <div
                  ref={refRSlide1}
                  className={`absolute right-[-100px] w-[220px] h-[313px] bg-[#a98a5ba5] rounded-[10px] opacity-0 z-20`}
                ></div>
                <div
                  ref={refRSlide2}
                  className={`absolute right-[10px] w-[220px] h-[313px] bg-[#a98a5b7c] rounded-[10px] `}
                ></div>
              </div>
              <div className="w-full flex items-center justify-center">
                <button
                  className=" w-[30px] h-[30px] rounded-full flex items-center justify-center border-[1px] border-color-primary-D text-color-primary-D text-[36px]"
                  onClick={backWardGr}
                >
                  <MdOutlineChevronRight />
                </button>

                <span className="w-[140px] h-[30px] flex items-center justify-center font-font_primary_A text-[12px] text-[#FFF] bg-color-primary-D rounded-[5px] mx-[16px] ">
                  {sliderData?.title}
                </span>
                <button
                  className="w-[30px] h-[30px] rounded-full flex items-center justify-center border-[1px] border-color-primary-D text-color-primary-D text-[36px] "
                  onClick={forwardGr}
                >
                  <MdOutlineChevronLeft />
                </button>
              </div>
            </div>
          </div>
        </div>

        <img
          src="../assets/images/other/big_polygonL.svg"
          className="absolute left-[-90px] top-[150px] w-[300px] h-[280px]"
        />

        <Footer />
      </div>
      <WorkWidthUsMobile />
    </>
  );
}
